var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { NumericFormat } from "react-number-format";
import { useCurrencyLocalizer } from "../hooks/useCurrencyLocalizer";
import { TextField } from "@mui/material";
import { forwardRef } from "react";
/**
 * Custom component to format numeric input using react-number-format
 *
 * @remarks [react-number-format docs](https://s-yadav.github.io/react-number-format/docs/props#custominput-reactcomponentany)
 */
export const NumericFormatCustom = forwardRef((props, ref) => {
    const { onChange } = props, other = __rest(props, ["onChange"]);
    const { currencySymbol } = useCurrencyLocalizer(props.value);
    return (_jsx(NumericFormat, Object.assign({}, other, { getInputRef: ref, onValueChange: (values) => {
            onChange({
                target: {
                    name: props.name,
                    value: values.value,
                },
            });
        }, customInput: TextField, decimalScale: 2, thousandSeparator: true, valueIsNumericString: true, prefix: currencySymbol })));
});
